"use client"

import type { ReactNode } from "react"

import Cookies from "js-cookie"
import posthog from "posthog-js"
import { PostHogProvider } from "posthog-js/react"

import { PostHogPageView } from "#analytics/posthog/posthogPageView"
import { ENVIRONMENT } from "#environment/env"

// Make sure we are on client
if (typeof window !== "undefined") {
  posthog.init(ENVIRONMENT.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: "/ingest",
    ui_host: "https://eu.posthog.com",
    person_profiles: "always",
    loaded: posthog => {
      // Disable event capturing in development or when started locally
      if (ENVIRONMENT.NEXT_PUBLIC_APP_ENV === "development" || !ENVIRONMENT.NEXT_PUBLIC_DEPLOYED) {
        posthog.set_config({ disable_session_recording: true })
        // Prevents making the actual request to posthog cloud in dev
        // custom debug mode in development
        posthog.capture = (...args) => {
          console.log("PostHog capture: ", ...args)
          return undefined
        }
      }
    },
    capture_pageview: false, // Disable automatic pageview capture, as we capture manually
    capture_pageleave: true,
    capture_heatmaps: true,
    capture_performance: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
      maskTextSelector: ".sensitive", // dont include text elements with sensitive class, for other non text elements, use the class ph-no-capture
      recordCrossOriginIframes: false,
    },
    autocapture: {
      capture_copied_text: true,
    },
  })

  const devMode = Cookies.get("INTERNAL_DEV_MODE")

  // Explicitly use values "true" and "false" because then only developers are targeted that had the mode set already and it doesnt impact customer devices, using /api/dev/off sets the INTERNAL_DEV_MODE cookie to "false" and does not remove it
  if (devMode === "true") {
    posthog.opt_out_capturing()
  } else if (devMode === "false") {
    posthog.clear_opt_in_out_capturing()
  }
}

export function PHProvider({ children }: { children: ReactNode }) {
  return (
    <PostHogProvider client={posthog}>
      <PostHogPageView />
      {children}
    </PostHogProvider>
  )
}
